// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper_bcdba","content":"NotFound_content_e5e89","search":"NotFound_search_c0327"};